import { getterTree, mutationTree, actionTree } from 'typed-vuex'
import { setState } from '~/lib/utils/store'
import { Streak } from '~/types/store'

export const DEFAULT_GOAL_CNT = 1

export const state = () => ({
  streaks: null as Streak.Streaks | null,
  goals: [
    {
      name: 'casual',
      text: '1 Application a week',
      isSelected: false,
      isPopular: false
    },
    {
      name: 'regular',
      text: '2 Applications a week',
      isSelected: true,
      isPopular: true
    },
    {
      name: 'serious',
      text: '3 Applications a week',
      isSelected: false,
      isPopular: false
    },
    {
      name: 'insane',
      text: '4+ Applications a week',
      isSelected: false,
      isPopular: false
    }
  ]
})

export const getters = getterTree(
  state,
  {
    streak({ streaks }) {
      return streaks && streaks.data[0]
    },
    selectedGoal(state, { streak }) {
      return streak ? streak.goalCnt - 1 : DEFAULT_GOAL_CNT
    },
    selectedGoalName({ goals }, { selectedGoal }) {
      return goals[selectedGoal] ? goals[selectedGoal].name : ''
    },
    // helpers
    lastStreakEvents({ streaks }, { streak }) {
      if (!streak || !streak.seq) { return [] }
      if (streak.seq > 1) { return [{ status: 'started', occurredAt: streak.startedAt }, { status: 'completed', occurredAt: streak.startedAt }] }
      return (streaks && streaks.meta.pagination.total > 1)
        ? [{ status: 'started', occurredAt: streak.startedAt }, { status: 'missed', occurredAt: streak.startedAt }]
        : [{ status: 'started', occurredAt: streak.startedAt }]
    },
    appliedOf(state, { streak }) {
      if (!streak) { return null }

      const appliedScholarshipsNumber = streak.applicationAutoCnt + streak.applicationManualCnt

      const applied = appliedScholarshipsNumber >= streak.goalCnt
        ? streak.goalCnt
        : appliedScholarshipsNumber

      return [applied, streak.goalCnt]
    }
  }
)

export const mutations = mutationTree(
  state,
  {
    setState
  }
)

export const actions = actionTree(
  { state, getters, mutations },
  {
    changeStreak({ dispatch, state }, attributes) {
      if (!state.streaks) { return }

      const actionName = state.streaks.data.length ? 'updateStreak' : 'createStreak'

      return dispatch(actionName, attributes)
        .then(() => dispatch('getStreaks'))
        .catch(e => this.$sentry.captureException(e))
    },
    createStreak({ rootGetters }, attributes) {
      const data = {
        data: {
          attributes: {
            ...attributes
          },
          relationships: {
            account: {
              data: {
                type: 'account',
                id: rootGetters['account/accountId']
              }
            }
          }
        }
      }

      return this.$api.gameStreak.createStreak(data)
    },
    updateStreak({ getters }, attributes) {
      if (!getters.streak) {
        return Promise.resolve()
      }

      const data = {
        data: {
          attributes: {
            ...attributes
          }
        }
      }

      return this.$api.gameStreak.updateStreak({ streakId: getters.streak.id }, data)
    },
    getStreaks({ commit, rootGetters }) {
      return this.$api.gameStreak.getStreaks({
        accountId: rootGetters['account/accountId'],
        attrs: { 'filter[latest]': 1, 'page[number]': 1, 'page[size]': 1 }
      }).then((res: Axios.AxiosResponse) => commit('setState', { stateName: 'streaks', data: res.data }))
    }
  }
)
